import CurrencyResource from "./currency.resource";

const currencyModule = angular
  .module("app.resources.currency", [])
  .service("Currency", CurrencyResource);

export default currencyModule;



// WEBPACK FOOTER //
// ./src/resources/currency/currency.module.js